<template>
    <div class="home">
        <div class="date_op">
            <DatePicker type="date" :placeholder="$t('select')+$t('date')" style="width: 200px"></DatePicker>
            ---
            <DatePicker type="date" :placeholder="$t('select')+$t('date')" style="width: 200px"></DatePicker>
            <Button type="primary">切换</Button>
        </div>
        <div class="detail">
            <div class="register item box_shadow">
                <div class="num">{{user}}</div>
                <div class="tit">注册数</div>
            </div>
            <div class="order item box_shadow">
                <div class="num">{{order}}</div>
                <div class="tit">订单数</div>
            </div>
            <div class="loan item box_shadow">
                <div class="num">{{order_success}}</div>
                <div class="tit">放款数</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            order: 0,
            order_success: 0,
            user: 0
        };
    },
    mounted(){
        this.loadData();
    },
    methods: {
        loadData() {
            this.$get(this.$path.home, {
                
            }).then(res => {
                if (res.data) {
                    this.order = res.data.order.count;
                    this.order_success = res.data.order_success.count;
                    this.user = res.data.user.count;
                } else {
                    this.$Message.error('获取数据失败');
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.home{
    .detail{
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        .item{
            width: 200px;
            height: 100px;
            border-radius: 6px;
            color: #ffffff;
            padding: 15px;
            margin-right: 20px;
            .num{
                height: 40px;
                line-height: 40px;
                font-size: 20px;
                text-align: center;
            }
            .tit{
                height: 20px;
                line-height: 20px;
                text-align: center;
            }
        }
        .register{
            background-image: linear-gradient(to bottom,#F9A87A,#F3674E);
        }
        .order{
            background-image: linear-gradient(to bottom,#FCD650,#FEB915);
        }
        .loan{
            background-image: linear-gradient(to bottom,#88B3FA,#6493FF);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/home/home.vue